import { useFirebaseAuth } from "vuefire";
import { useState } from "#app";

export const useStudentLogout = () => {
  const isLoggingOut = useState("student-logout-in-progress", () => false);
  const auth = useFirebaseAuth();

  const logout = async () => {
    if (isLoggingOut.value) return;

    isLoggingOut.value = true;
    try {
      if (!auth) throw new Error("Authentication is unavailable");

      await auth.signOut();
      // Unload the dashboard and its listeners, even if client routing is stuck.
      window.location.replace("/auth/login");
    } catch {
      isLoggingOut.value = false;
      useBaseToast("Unable to log out. Please try again.", "error");
    }
  };

  return { isLoggingOut, logout };
};
